<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="operationSegmentSpecs$ | async"
    [selectionVisible]="true"
    [selectionMultiEnabled]="true"
    (itemClick)="onOperationClicked($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      [canAdd]="true"
      [canRemove]="true"
      [canMore]="false"
      (requestNew)="addOperation()"
      (requestRemove)="onRemoveOperations($event)"
    >
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
      <td mat-cell *matCellDef>
        <mat-icon>build</mat-icon>
      </td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let i = index">OP{{ i }}</td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let op">{{ op.action }}</td>
    </ng-container>

    <!-- action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
        {{ 'process.actions.action' | translate }}
      </th>
      <td mat-cell *matCellDef="let op">{{ op.action }}</td>
    </ng-container>

    <!-- instructions -->
    <ng-container matColumnDef="instructions">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">
        {{ 'instructions.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let op">
        <div class="place-start-center">
          <button mat-icon-button (click)="openInstructions(op)" elderStopEventPropagation>
            <mat-icon>highlight_alt</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <!-- material mappings -->
    <ng-container matColumnDef="material-mappings">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'Mappings' | translate }}
      </th>
      <td mat-cell *matCellDef="let op">
        <div class="place-start-center">
          <button
            mat-icon-button
            elderStopEventPropagation
            (click)="openMappings(op)"
            [disabled]="!(materialMappingsEnabled$ | async)"
            [matTooltip]=""
          >
            <mat-icon>highlight_alt</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <!-- order controls -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
      <td mat-cell *matCellDef="let op">
        <div class="place-start-center">
          <button mat-icon-button (click)="moveUp(op)" elderStopEventPropagation>
            <mat-icon>arrow_drop_up</mat-icon>
          </button>
          <button mat-icon-button (click)="moveDown(op)" elderStopEventPropagation>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
  </elder-table>
</div>
